import React from 'react';
import ReactApexChart from 'react-apexcharts';

const CompactBar = ({ value, max, color }) => {
  const options = {
    chart: {
      type: 'bar',
      sparkline: { enabled: true },
      animations: { enabled: true },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        borderRadius: 3,
        barHeight: '75%',
      },
    },
    colors: [color],
    xaxis: { max },
    tooltip: { enabled: false },
  };

  return <ReactApexChart options={options} series={[{ data: [value] }]} type="bar" height={28} />;
};

const UserByVillageChart = ({ villageData = [] }) => {
  const maxUsers =
    villageData.length > 0 ? Math.max(...villageData.map((d) => d.FarmerCount || 0)) : 100;

  const colors = ['#126B3A', '#1B9652', '#25C36C', '#3BE286', '#AFFBD1', '#DEFFED'];

  return (
    <div className="col-12 col-xl-6">
      <div className="card shadow-sm border-0 h-100">
        <div className="card-body p-3">
          <h6 style={{ color: '#1B5E20', fontWeight: 'bold', fontSize: '18px', marginBottom: '20px' }}>
            User By Village
          </h6>

          {villageData.slice(0, 5).map((item, index) => (
            <div key={index} style={{ marginBottom: '12px' }}>
              <div
                style={{
                  fontSize: '10px',
                  color: '#6c757d',
                  marginBottom: '4px',
                  wordBreak: 'break-word',
                }}
              >
                {item.ProvinceOrStateName} | {item.DistrictName} | {item.CommuneName} |{' '}
                {item.VillageName}
              </div>

              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '55px minmax(0, 1fr) 50px',
                  alignItems: 'center',
                  columnGap: '8px',
                }}
              >
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={`https://api.soksan-dss.com/uploads/flag/${item.ImageForCountry}`}
                    alt={item.CountryName}
                    style={{ width: '30px', height: '20px', borderRadius: '2px', objectFit: 'cover' }}
                    onError={(e) => {
                      e.target.src = 'https://via.placeholder.com/30x20?text=?';
                    }}
                  />
                  <div
                    style={{
                      fontSize: '9px',
                      fontWeight: 'bold',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      marginTop: '2px',
                    }}
                  >
                    {item.VillageName.split(' ')[0]}
                  </div>
                </div>

                <CompactBar
                  value={item.FarmerCount}
                  max={maxUsers}
                  color={colors[index] || colors[colors.length - 1]}
                />

                <div style={{ fontSize: '14px', fontWeight: 'bold', textAlign: 'right', color: '#333' }}>
                  {item.FarmerCount.toLocaleString()}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default UserByVillageChart;
